import { memo } from 'react'
import { Box, Card } from '@mui/material'
import Autoplay from 'embla-carousel-autoplay'

import { Image } from '../image'
import Text from '../text/Text'
import featuredBanner1 from 'assets/featured1.jpg'

import {
  Carousel,
  CarouselArrowBasicButtons,
  CarouselDotButtons,
  useCarousel
} from '../carousel'

const AppFeatured = ({ t, sx, ...other }) => {
  const carousel = useCarousel({ loop: true }, [
    Autoplay({ playOnInit: true, delay: 8000 })
  ])
  const list = [
    {
      heading: t('home.coming-soon'),
      title: t('home.coming-soon-title'),
      desc: t('brand:home.featured-banner-desc'),
      coverUrl: featuredBanner1
    }
  ]

  return (
    <Card
      sx={[
        { bgcolor: 'common.black', height: 1 },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...other}
    >
      <CarouselDotButtons
        scrollSnaps={carousel.dots.scrollSnaps}
        selectedIndex={carousel.dots.selectedIndex}
        onClickDot={carousel.dots.onClickDot}
        sx={{
          top: 16,
          left: 16,
          position: 'absolute',
          color: 'primary.light'
        }}
      />

      <CarouselArrowBasicButtons
        {...carousel.arrows}
        options={carousel.options}
        sx={{
          top: 8,
          right: 8,
          position: 'absolute',
          color: 'common.white'
        }}
      />

      <Carousel carousel={carousel}>
        {list.map((item) => (
          <CarouselItem key={item.heading} item={item} />
        ))}
      </Carousel>
    </Card>
  )
}

function CarouselItem({
  item: { heading, title, desc, coverUrl },
  sx,
  ...other
}) {
  return (
    <Box
      sx={[
        {
          width: 1,
          position: 'relative'
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...other}
    >
      <Box
        sx={{
          p: 3,
          gap: 1,
          width: 1,
          bottom: 0,
          zIndex: 9,
          display: 'flex',
          position: 'absolute',
          color: 'common.white',
          flexDirection: 'column'
        }}
      >
        <Text
          variant='overline'
          sx={{ color: 'primary.light' }}
          label={heading}
        />
        <Text color='inherit' underline='none' variant='h5' label={title} />
        <Text variant='body2' label={desc} />
      </Box>

      <Image
        alt={title}
        src={coverUrl}
        slotProps={{
          overlay: {
            sx: (theme) => ({
              backgroundImage: `linear-gradient(to bottom, transparent 0%, ${theme.vars.palette.common.black} 75%)`
            })
          }
        }}
        sx={{ width: 1, height: { xs: 288, xl: 320 } }}
      />
    </Box>
  )
}

export default memo(AppFeatured)
